import React from "react";
import { ListItemIcon, ListItemIconProps, useTheme } from "@material-ui/core";

interface DenseIconProps extends ListItemIconProps {
  centered?: boolean;
}

export const DenseIcon = (props: DenseIconProps) => {
  const theme = useTheme();
  const {centered=false, children, ...other} = props;

  return (
    <ListItemIcon
      {...other}
      style={{
        minWidth:theme.spacing(0),
        paddingRight: "10px",
        alignItems: centered ? "center" : "inherit"
      }}
    >
      {children}
    </ListItemIcon>
  );
};